export default __webpack_public_path__ + "static/topicals-b843bc2e2e560aa702d81577169a0757.png";